var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatLongIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6518 14.5743C21.3024 11.7878 19.091 9.57655 16.3046 9.22711V7.62988H14.7616V9.22638C11.9744 9.57649 9.76307 11.7879 9.41363 14.5743H7.81641V16.1173H9.41291C9.76302 18.9045 11.9744 21.1158 14.7609 21.4653V23.0625H16.3038V21.466C19.0911 21.1159 21.3024 18.9045 21.6518 16.118H23.249V14.5751L21.6518 14.5743ZM20.0929 16.118C19.7659 18.0523 18.2388 19.5793 16.3046 19.9063V18.4328H14.7616V19.9063C12.8266 19.5794 11.2996 18.0523 10.9725 16.118H12.446V14.575L10.9725 14.5743C11.2995 12.6401 12.8266 11.113 14.7609 10.786V12.2595H16.3038L16.3045 10.786C18.2388 11.113 19.7658 12.6401 20.0929 14.5743H18.6194V16.1173L20.0929 16.118Z",
    fill: "black",
    fillOpacity: 0.51
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatLongIcon);
export default __webpack_public_path__ + "static/media/LatLongIcon.4ff575fa56fea2610729bcea1e6ca178.svg";
export { ForwardRef as ReactComponent };